import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import Select from '../../../Part_Sample/Select';

export default class Start_Date extends Component {
	constructor(props) {
		super(props);
		let start_day = 1;
		let start_month = 0;

		if (!isEmpty(this.props.report_settings)) {
			if (!isEmpty(this.props.report_settings.start_day)) start_day = this.props.report_settings.start_day;
			if (!isEmpty(this.props.report_settings.start_month)) start_day = this.props.report_settings.start_month;
		}

		this.state = {}
	}

	handleChangeMonth = (val) => {
		let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
		let start_month_date = new Date();
		start_month_date.setDate(1);
		start_month_date.setMonth(val);
		let num_days = new Date(start_month_date.getFullYear(), start_month_date.getMonth() + 1, 0).getDate();
		// If the start day has a date which is more than the number of days in selected month
		// Start day will be the last day of the selected month
		if (report_settings.start_day > num_days) report_settings.start_day = num_days;

		report_settings.start_month = val;
		this.props.handleModifyCategories(report_settings);
	}

	handleChangeDate = (val) => {
		let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
		report_settings.start_day = val;
		this.props.handleModifyCategories(report_settings);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let card_style = {
			background: 'white',
			padding: '0px 10px',
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
			textAlign: 'left',
		}

		let months = [];
		let dates = [];

		for (let i = 0; i < 12; i++) {
			if (this.props.report_settings.start_month == i) {
				months.push(<option selected='selected' value={i}>{this.props.receiver.getString('month' + (parseInt(i) + 1))}</option>);
			}
			else {
				months.push(<option value={i}>{this.props.receiver.getString('month' + (parseInt(i) + 1))}</option>);
			}
		}

		let month = new Date();
		month.setDate(1);
		month.setMonth(this.props.report_settings.start_month);
		let num_days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();

		for (let i = 1; i <= num_days; i++) {
			let date_string = i
			if (i < 10) {
				date_string = "0" + i
			}
			if (this.props.report_settings.start_day == i) {
				dates.push(<option selected='selected' value={i}>{date_string}</option>);
			}
			else {
				dates.push(<option value={i}>{date_string}</option>);
			}
		}

		return (
			<div style={style}>
				<div style={{ overflow: 'auto', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)', borderRadius: 20 }}>
					<div style={{ textAlign: 'left', marginLeft: 10 }}>
						<span className="header">{this.props.receiver.getString('start_date_month')}</span>
					</div>
					<div style={{ textAlign: 'left' }}>
						<span className='footnote' style={{ fontSize: 12 }}>{this.props.receiver.getString('start_date_explanation')}</span>
					</div>
					<div style={card_style}>
						<div style={{ display: 'inline-block', width: this.props.width - 240 }}>
							<span style={{ fontSize: 20 }}>{this.props.receiver.getString('month')}</span>
						</div>
						<Select
							style={{ display: 'inline-block', width: 170 }}
							select_style={{ width: 170, fontSize: 20 }}
							options={months}
							value={this.props.report_settings.start_month}
							onSelect={this.handleChangeMonth}
						/>
						<div style={{ display: 'inline-block', width: this.props.width - 240, marginTop: 20, marginBottom: 20 }}>
							<span style={{ fontSize: 20 }}>{this.props.receiver.getString('date')}</span>
						</div>
						<Select
							style={{ display: 'inline-block', width: 170 }}
							select_style={{ width: 170, fontSize: 20 }}
							options={dates}
							value={this.props.report_settings.start_day}
							onSelect={this.handleChangeDate}
						/>
					</div>
				</div>
			</div>
		)
	}
}